import {Component, ViewEncapsulation} from '@angular/core';
import {ResponseDtoType} from '../../../dto/ResponseDtoType';
import {ImmediatelyRenderedMessageComponent} from '../immediately-rendered-message-component';

@Component({
    templateUrl: './files-message.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class FilesMessageComponent extends ImmediatelyRenderedMessageComponent {

    public static TYPE: ResponseDtoType = 'files';

}
